import { useEffect, useState } from "react";

const IDLE_TIMEOUT_MS = 2000;
const NO_IDLE_FALLBACK_MS = 500;

/** True once the page has loaded and the browser is idle, so heavy decorative media doesn't compete with LCP. */
export function useAfterPageLoad(): boolean {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let idleHandle: number | undefined;
    let timer: number | undefined;
    const markReady = () => setReady(true);
    const schedule = () => {
      const ric = window.requestIdleCallback?.bind(window);
      if (ric) {
        idleHandle = ric(markReady, { timeout: IDLE_TIMEOUT_MS });
      } else {
        timer = window.setTimeout(markReady, NO_IDLE_FALLBACK_MS);
      }
    };

    if (document.readyState === "complete") {
      schedule();
    } else {
      window.addEventListener("load", schedule, { once: true });
    }

    return () => {
      window.removeEventListener("load", schedule);
      if (idleHandle !== undefined) window.cancelIdleCallback(idleHandle);
      if (timer !== undefined) window.clearTimeout(timer);
    };
  }, []);

  return ready;
}
